@let product = productLine.product;
<tr class="product">
  <td class="product-info">
    <a [routerLink]="productLine.giftCardInfo ? giftCardUrl : createProductUrl(product)">
      <div class="basket-product-image-container">
        <img [src]="product | primary" [alt]="product.productDisplayName" (load)="cdr.detectChanges()" />
      </div>
      <div class="basket-product-description">
        <b>{{ product.productDisplayName }}</b>
        @if (product.summary && !simple) {
          <span>{{ product.summary }}</span>
        }
        @if (simple && product | modules; as moduleChoices) {
          @if (moduleChoices?.length) {
            <div class="simple-modules">
              @for (module of moduleChoices; track module.id) {
                <span>{{ module.moduleParentName }}: {{ module.productDisplayName }}</span>
              }
            </div>
          }
        }
      </div>
    </a>
  </td>
  <td class="mobile-product-info mobile-basket-product-image-container">
    <a [routerLink]="productLine.giftCardInfo ? giftCardUrl : createProductUrl(product)">
      <div class="basket-product-image-container">
        <img [src]="product | primary" [alt]="product.productDisplayName" (load)="cdr.detectChanges()" />
      </div>
    </a>
  </td>
  <td class="mobile-product-info mobile-basket-product-description" [class.simple]="simple">
    <div class="basket-product-description">
      <b>{{ product.productDisplayName }}</b>
      @if (simple && product | modules; as moduleChoices) {
        @if (moduleChoices?.length) {
          <div class="simple-modules">
            @for (module of moduleChoices; track module.id) {
              <span>{{ module.moduleParentName }}: {{ module.productDisplayName }}</span>
            }
          </div>
        }
      }
    </div>
  </td>
  <td class="product-price">
    <label for="product-price">{{ columns.price }}</label>
    <span id="product-price">
      {{ (productLine | sum) / productLine.quantity | number: '.2-2' : locale }} {{ currency | displayCurrency }}
    </span>
  </td>
  <td class="basket-price">
    <label for="total-price">{{ columns.total }}</label>
    <span id="total-price">{{ productLine | sum | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
  </td>
  @if (!productLine.giftCardInfo) {
    <td class="basket-product-quantity">
      <app-counter
        [minCount]="product.minCount"
        [lockRemove]="productLine.quantity === product.minCount"
        [count]="productLine.quantity"
        [packageOptions]="product.packageOptions"
        (add)="addProduct(product, $event.quantity, $event.packageOptions)"
        (remove)="removeProduct(product, $event.quantity, $event.packageOptions)"
      ></app-counter>
    </td>
  }
  @if (productLine.giftCardInfo) {
    <td class="basket-product-quantity">
      <div>{{ productLine.quantity }}</div>
    </td>
  }
  <td class="basket-remove-product">
    <app-icon-button [icon]="deleteLineIcon" [border]="false" (click)="deleteProduct(product)"></app-icon-button>
  </td>
</tr>

@let moduleChoices = !simple && product | modules;
@if (moduleChoices?.length) {
  <div class="modules">
    @for (module of moduleChoices; track module.id) {
      <tr class="module-line">
        <td class="product-info">
          <div class="basket-product-image-container">
            <img [src]="module | primary" [alt]="module.productDisplayName" (load)="cdr.detectChanges()" />
          </div>
          <div class="basket-product-description">
            <b>{{ module.productDisplayName }}</b>
            @if (product.summary) {
              <span>{{ module.summary }}</span>
            }
          </div>
        </td>
        <td class="basket-product-quantity">
          <div class="module-quantity">
            @if (module.price || module.quantity !== 1) {
              <div>
                {{ module.quantity }}
                @if (productLine.quantity !== 1) {
                  <mat-icon [svgIcon]="multiplyIcon" class="multiply-icon"></mat-icon>
                }
                {{ productLine.quantity !== 1 ? productLine.quantity : '' }}
              </div>
            }
          </div>
        </td>
      </tr>
    }
  </div>
}
